import { SortParams } from '@epicuro-next/data/baskets';

import { SortParamsTuple } from '../models';

export function tupleToSortParams(
  defaultSorting: SortParamsTuple,
): Partial<SortParams> {
  const [type, direction] = defaultSorting;

  return { type, direction };
}
